// Bayo theme — light interactions
(function(){
  // quantity steppers
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-qty]'); if(!b) return;
    var wrap=b.closest('.stepper'); var input=wrap.querySelector('input');
    var v=parseInt(input.value)||1; v += (b.dataset.qty==='up'?1:-1); if(v<1)v=1;
    input.value=v; input.dispatchEvent(new Event('change',{bubbles:true}));
  });
})();

// mobile menu behaviour
(function(){
  var nav=document.querySelector('.nav-links');
  var btn=document.querySelector('.nav-toggle');
  if(!nav||!btn) return;
  function close(){ nav.classList.remove('open'); btn.setAttribute('aria-expanded','false'); }
  btn.setAttribute('aria-expanded','false');
  btn.addEventListener('click',function(){
    setTimeout(function(){ btn.setAttribute('aria-expanded', nav.classList.contains('open')?'true':'false'); },0);
  });
  nav.addEventListener('click',function(e){ if(e.target.tagName==='A') close(); });
  document.addEventListener('click',function(e){
    if(nav.classList.contains('open') && !nav.contains(e.target) && !btn.contains(e.target)) close();
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  window.addEventListener('resize',function(){ if(window.innerWidth>900) close(); });
})();
